export const TalentRowExperienceLabel = ({
  label,
  experienceYear,
}: {
  label: string;
  experienceYear?: number | null;
}) => {
  return (
    <p className="flex min-w-0 items-center gap-1 text-xs font-normal leading-5 tracking-[0.36px] text-[#2F3F3F]">
      <span className="min-w-0 truncate" title={label}>
        {label}
      </span>
      {experienceYear != null ? (
        <span className="shrink-0 rounded bg-[#F7F8F8] px-1 text-[10px] font-normal leading-4 tracking-[0.3px] text-[#596C6C]">
          {experienceYear}年
        </span>
      ) : null}
    </p>
  );
};

export const TalentRowOverflowCountLabel = ({ label }: { label: string }) => {
  return (
    <span className="inline-flex w-fit items-center rounded bg-[#F7F8F8] px-1 text-[10px] font-normal leading-4 tracking-[0.3px] text-[#596C6C]">
      {label}
    </span>
  );
};

export const isTalentRowActionTarget = (target: EventTarget | null, root?: EventTarget & Node) => {
  if (!(target instanceof Element)) {
    return false;
  }

  const action = target.closest('button,a,input,textarea,select,[data-talent-row-action="true"]');
  if (!action) {
    return false;
  }

  // root を渡したときは、カード外の祖先 a/button への誤マッチを防ぐ
  return root ? root.contains(action) : true;
};

export const formatTalentRange = (min?: number | null, max?: number | null) => {
  if (min != null && max != null) {
    return `${min.toLocaleString()} - ${max.toLocaleString()}`;
  }

  if (min != null) {
    return `${min.toLocaleString()} -`;
  }

  if (max != null) {
    return `- ${max.toLocaleString()}`;
  }

  return '-';
};
